import { useMatch, useParams } from 'react-router';

import {
  LOCATION_PATH,
  MENU_PATH,
  POS_MENU_SETTINGS_PATH,
  POS_MENU_SETTINGS_ROUTE,
} from 'constants/path';

/**
 * Where the menu editor's exits (Cancel, the missing-merchant redirect) should land.
 * The editor is mounted under both Menu Editor and POS Menu Settings, so the list it
 * came from depends on the route, not on the component.
 */
export const useMenuListPath = (): string => {
  const { restaurantId } = useParams();
  const isPosMenuSettingsRoute = !!useMatch(POS_MENU_SETTINGS_ROUTE);

  const listPath = isPosMenuSettingsRoute ? POS_MENU_SETTINGS_PATH : MENU_PATH;

  return `${LOCATION_PATH}/${restaurantId}${listPath}`;
};
